export default __webpack_public_path__ + "static/media/Coffee-Gable-Coffee-Discovery-2.3b7310c3.jpg";